import React, { useState, useContext } from 'react';
import { Row, Col, Steps, Icon, Tag } from 'antd';
import { AuthContext } from '../../../context/auth';
import VerifyEmail from './verify-email';
import VerifyDocuments from './verify-documents';
import VerifyMobile from './verify-mobile';
import CompleteProfile from './complete-profile';

const { Step } = Steps;

function VerifiedBadge() {
    return (<Tag style={{ color: 'green', borderColor: 'green', backgroundColor: 'rgba(0,200,0,0.05)' }}>تأیید شده</Tag>)
}

function UnVerifiedBadge() {
    return (<Tag style={{ color: '#ff5555', borderColor: '#ff4444', backgroundColor: 'rgba(200,0,0,0.05)' }}>تأیید نشده</Tag>)
}

export default function ActivateAccount() {
    const { user } = useContext(AuthContext);

    const checkProfileCompleted = () => {
        if(user.user.full_name !== null && user.user.mobile_number !== null && user.user.nation_code !== null && user.user.is_company !== null){
            return true;
        }
        else return false;
    }

    const checkDocsApproved = () => {
        if(user.user.documents_status === "approved"){
            return true;
        }
        else return false;
    }

    const [profileCompleted, setProfileCompleted] = useState(checkProfileCompleted());
    const [mobileVerified, setMobileVerified] = useState(user.user.mobile_verified);
    const [emailVerified, setEmailVerified] = useState(user.user.email_verified);
    const [documentsVerified, setDocumentsVerified] = useState(checkDocsApproved());
    
    
    var findCurrentStep = 0;

    if(!emailVerified){
        findCurrentStep = 0;
    }
    else if( emailVerified && !profileCompleted ){
        findCurrentStep = 1;
    }

    else if(emailVerified && profileCompleted && !mobileVerified){
        findCurrentStep = 2;
    }

    else if(profileCompleted && mobileVerified && emailVerified && !documentsVerified){
        findCurrentStep = 3;
    }

    const [current, setCurrent] = useState(findCurrentStep);
    
    const steps = [
        {
            title: 'تأیید ایمیل',
            content: <VerifyEmail verified={emailVerified} email={user.user.email}/>,
            subtitle: emailVerified ? (<VerifiedBadge />) : (<UnVerifiedBadge />),
            icon: 'mail'
        },
        {
            title: 'تکمیل اطلاعات',
            content: <CompleteProfile verified={profileCompleted}/>,
            subtitle: profileCompleted ? (<VerifiedBadge />) : (<UnVerifiedBadge />),
            icon: 'form'
        },
        {
            title: 'تایید موبایل',
            content: <VerifyMobile verified={mobileVerified} phoneNumber={'09398439962'} />,
            subtitle: mobileVerified ? (<VerifiedBadge />) : (<UnVerifiedBadge />),
            icon: 'mobile',
        },
        {
            title: 'آپلود مدارک',
            content: <VerifyDocuments />,
            subtitle: documentsVerified ? (<VerifiedBadge />) : (<UnVerifiedBadge />),
            icon: 'upload'
        },
    ];

    return (
        <div style={{minHeight : '90vh'}}>
            <div className="container">
                <div className="indevelopment" style={{paddingTop : '100px'}}>
                    <Row className={"indevelopmentRow"}>
                        <Col xs={24} sm={24} md={20} lg={20} xl={18}>
                            <div className="InDevelopmentCard">
                                <div className="inDevText">
                                    <Steps current={current}>
                                        {steps.map(item => {
                                            return (
                                                <Step key={item.title} title={item.title} description={item.subtitle} icon={<Icon type={item.icon} />} />
                                            );
                                        })}
                                    </Steps>
                                    <div className={"admin-steps-content"}>
                                        {steps[current].content}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}
